module.exports = __webpack_public_path__ + "static/media/fracture-tornillo.aa3ebb0d.png";